export const getTelephonyProviderInfo = (providerType?: string) => {
  switch (providerType) {
    case "twilio":
      return { icon: "twilio", name: "Twilio" };
    case "telnyx":
      return { icon: "telnyx", name: "Telnyx" };
    case "infobip":
      return { icon: "infobip", name: "Infobip" };
    case "mock-voicerun":
      return { icon: "mock-voicerun", name: "Mock VoiceRun" };
    default:
      return { icon: "voicerun", name: "VoiceRun" };
  }
};
